<div class="workflow-node-parameters__event-filters">
  <app-mat-simple-select
    [label]="fieldLabels['provider']"
    [formControl]="providerFormControl"
    [selectItems]="transcriptionProviders"
    (valueChanged)="onProviderChange()"
  ></app-mat-simple-select>

  <app-mat-simple-select
    [searchEnabled]="true"
    [label]="fieldLabels['language']"
    [formControl]="languageFormControl"
    [selectItems]="deepgramLanguage"
  ></app-mat-simple-select>

  <app-mat-simple-select
    [searchEnabled]="true"
    [label]="fieldLabels['model']"
    [formControl]="modelFormControl"
    [selectItems]="availableModels"
  ></app-mat-simple-select>

  <app-mat-textarea-input
    [label]="fieldLabels['summarySystemPrompt']"
    [formControl]="systemPromptFormControl"
    placeholder="e.g. You are a helpful assistant that summarizes texts clearly and concisely."
  >
  </app-mat-textarea-input>
  <app-mat-textarea-input
    [label]="fieldLabels['summaryUserPrompt']"
    [formControl]="userPromptFormControl"
    placeholder="e.g. Please provide a clear, concise summary of the following text:"
  >
  </app-mat-textarea-input>

  <app-mat-slide-toggle-input
    [label]="fieldLabels['skipStorage']"
    [formControl]="skipStorageFormControl"
    explanation="Transcription results will not be saved and will only be passed to the following actions (e.g. Send to URL)."
  ></app-mat-slide-toggle-input>

  <div class="extension-overrides">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="extension-overrides__header">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
        <span>Extension Overrides</span>
        <mat-icon
          class="extension-overrides__info-icon"
          matTooltip="Override transcription language for specific extensions. Each override applies the selected language to the listed extensions, instead of the default language."
          >info</mat-icon
        >
      </div>
      <button mat-raised-button (click)="addExtensionOverride()">+ Add</button>
    </div>
    <div
      *ngFor="let override of extensionOverridesArray.controls; let i = index"
      [formGroup]="$any(override)"
      fxLayout="row"
      fxLayoutAlign="space-between start"
      class="extension-override-row"
    >
      <div fxFlex fxLayout="column">
        <app-mat-multiselect
          label="Extensions *"
          [allowCustomValue]="true"
          [required]="true"
          [formControl]="$any(override.get('extensions'))"
        ></app-mat-multiselect>
        <app-mat-simple-select
          [searchEnabled]="true"
          label="Language Override"
          [required]="true"
          [selectItems]="deepgramLanguage"
          [formControl]="$any(override.get('language'))"
        ></app-mat-simple-select>
      </div>
      <button mat-icon-button class="extension-override-row__delete" (click)="removeExtensionOverride(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</div>
